export const pricePageDict = {
  en: {
    title: 'Calculate the cost',
    primaryButton: 'Get the cost calculation',
    label: 'Individual cost calculation',
  },
  ru: {
    title: 'Рассчитать стоимость',
    primaryButton: 'Получить расчет на почту',
    label: 'Индивидуальный расчет стоимости',
  },
  de: {
    title: 'Berechnen Sie die Kosten',
    primaryButton: 'Erhalten Sie die Kostenberechnung per E-Mail',
    label: 'Individuelle Kostenkalkulation',
  },
  tr: {
    title: 'Maliyeti Hesaplayın',
    primaryButton: 'E-posta ile maliyet hesaplamasını alın',
    label: 'Bireysel maliyet hesaplaması',
  },
  es: {
    title: 'Calcular el costo',
    primaryButton: 'Recibir el cálculo de costos por correo electrónico',
    label: 'Cálculo de costos individual',
  },
};
